// This file is just added for convenience so this repository can be
// directly checked out into a project's deps folder
module.exports = require('./lib/xmldoc');



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/xmldoc/index.js